import { render } from "./general-wellness.vue?vue&type=template&id=51edfd5c&scoped=true"
import script from "./general-wellness.vue?vue&type=script&lang=js"
export * from "./general-wellness.vue?vue&type=script&lang=js"

import "./general-wellness.vue?vue&type=style&index=0&id=51edfd5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51edfd5c"]])

export default __exports__